import React from 'react';
import {
  Pressable, StyleSheet, Text, View,
  ViewStyle,
} from 'react-native';
import { PressableState } from '../../../PressableStyled';
import Style from '../../../../constants/Style';
import Colors from '../../../../constants/Colors';
import UpArrow12 from '../../../12pxIcons/UpArrow12';

interface TimeTileProps {
  title: string,
  time: string,
  percentage: number,
  style: ViewStyle | ViewStyle[],
}

const TimeTile = ({
  title, time, percentage, style,
}: TimeTileProps) => {
  let color: string = Colors.light.hereworksPrimaryGrey700;
  if (percentage > 0) color = Colors.light.hereworksGreen500;
  else if (percentage < 0) color = Colors.light.hereworksRed500;

  return <Pressable
    style={(state: PressableState) => [styles.item, state.hovered && Style.listItemHovered, style]}>
    <Text style={styles.title}>{title ?? '-'}</Text>
    <Text style={styles.time}>{time ?? '-'}</Text>
    <View style={Style.row}>
      <UpArrow12 {...{ color }} />
      <Text style={[styles.title, { color }]}>
        {`${percentage ?? '-'}%`}
      </Text>
    </View>
  </Pressable>;
};

const styles = StyleSheet.create({
  item: {
    borderRadius: 8,
    padding: 8,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 152,
    width: 348,
  },
  title: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
  },
  time: {
    fontSize: 30,
    lineHeight: 30,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_600SemiBold',
    margin: 4,
    marginBottom: 8,
  },
});

export default TimeTile;
